import React, { FC, useRef, useState, useEffect } from "react";
import ImgPlayVideo from '@/shared/pictures/play_video.png';

interface CustomVideoProps {
    url: string,
    poster: string
}

export const CustomVideo:FC<CustomVideoProps> = ({url,poster}) => {
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const [isPlaying, setIsPlaying] = useState(false);


  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const handleFsChange = () => {
      const isFullscreen =
        document.fullscreenElement === video ||
        (document as any).webkitFullscreenElement === video;

      if (!isFullscreen) {
        stopVideo();
      }
    };

    document.addEventListener("fullscreenchange", handleFsChange);
    document.addEventListener("webkitfullscreenchange", handleFsChange);
    video.addEventListener("webkitendfullscreen", stopVideo);

    return () => {
      document.removeEventListener("fullscreenchange", handleFsChange);
      document.removeEventListener("webkitfullscreenchange", handleFsChange);
      video.removeEventListener("webkitendfullscreen", stopVideo);
    };
  }, []);

  const enterFullscreen = () => {
    const video = videoRef.current;
    if (!video) return;

    if (video.requestFullscreen) {
      video.requestFullscreen();
    }
    else if ((video as any).webkitEnterFullscreen) {
      (video as any).webkitEnterFullscreen();
    }
    else if ((video as any).webkitRequestFullscreen) {
      (video as any).webkitRequestFullscreen();
    }
  };

  const playVideo = () => {
    if (!videoRef.current) return;
    videoRef.current.play().then(() => {
      enterFullscreen();
    });
    setIsPlaying(true);
  };

  const stopVideo = () => {
    if (!videoRef.current) return;
    videoRef.current.pause();
    setIsPlaying(false);
  };

  return (
    <div className="video-block">

      {!isPlaying ? (
        <div className="video-block_overflow" onClick={playVideo}>
          <div className="video-block_control">
            <img className="video-block_control-img" src={ImgPlayVideo} alt="play" />
          </div>
        </div>
      ) : (
        <div className="video-block_overflow" onClick={stopVideo}></div>
      )}

      <video
        ref={videoRef}
        poster={poster}
        src={url}
        style={{ width: "100%", height: 'auto' }}
        onEnded={() => setIsPlaying(false)}
      />
    </div>
  );
}